export const indefiniteArticle = function() {
  return function (input) {
    return input.match(/^[aieouAIEOU].*/) ? "an" : "a";
  };
};
